import { z } from 'zod'
import QuestionWrapper from '../../questionnaire/formSteps/QuestionWrapper'

export const includedEnergyPlanOptions = [
  {
    id: 'predictableMonthlyBill',
    label: 'Predictable monthly bill',
    checked: false,
  },
  {
    id: 'lowestTotalYearlyCost',
    label: 'Lowest total yearly cost',
    checked: false,
  },
  {
    id: 'topRatedService',
    label: 'Top-rated service and support',
    checked: false,
  },
  { id: 'greenEnergy', label: 'Green energy', checked: false },
  {
    id: 'billCredits',
    label: 'Bill credits (only show bill credit plans)',
    checked: false,
  },
]

export const energyPlanIncludes = {
  component: QuestionWrapper,
  componentProps: {
    title: 'What are you searching for in an energy plan?',
    label: 'Plan preferences',
    subtitle: 'Select all that apply.',
    options: includedEnergyPlanOptions,
    formValue: 'energyPlanIncludes',
    tooltip: 'Knowing your priorities helps us match you with the right plan for your lifestyle.',
    canSkip: true,
    tracking: {
      stepName: 'Plan Search Priorities',
      deepStepNumber: 6,
      deepStepId: '6',
      quickStepNumber: 2,
      quickStepId: '6',
      fieldName: 'plan_priorities',
    },
  },
  name: 'energyPlanIncludesCheckboxGroup',
  coreIf: true, // Always core - drives recommendations
  schema: z.object({
    energyPlanIncludes: z.array(z.string()).optional(),
  }),
}
